import { makeStyles } from "@material-ui/core/styles";

export const useStylesBoa = makeStyles((theme) => ({
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: "100%",
  },
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    border: "none !important",
    padding: "50px",
    width: "615px",
    position: "relative",
    borderRadius: "10px",
    [theme.breakpoints.down("sm")]: {
      padding: " 20px 20px 20px 20px !important",
      overflow: "auto !important",
      width: "92% !important",
    },
    "&:focus": {
      outline: "none",
    },
  },
  root: {
    "label + &": {
      marginTop: theme.spacing(3),
    },
  },
  input: {
    borderRadius: 4,
    position: "relative",
    backgroundColor: theme.palette.background.paper,
    border: "1px solid #ced4da",
    fontSize: 16,
    padding: "10px 26px 10px 12px",
    transition: theme.transitions.create(["border-color", "box-shadow"]),
    // Use the system font instead of the default Roboto font.
    fontFamily: [
      "-apple-system",
      "BlinkMacSystemFont",
      '"Segoe UI"',
      "Roboto",
      '"Helvetica Neue"',
      "Arial",
      "sans-serif",
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(","),
    "&:focus": {
      borderRadius: 4,
      borderColor: "#80bdff",
      boxShadow: "0 0 0 0.2rem rgba(0,123,255,.25)",
    },
  },
  formControl: {
    minWidth: "100%",
    maxWidth: "100%",
    position: "relative",
  },
  selectOptions: {
    width: "45%",
    marginTop: "2rem",
    position: "absolute !important",
    "& .MuiListItem-root": {
      borderRadius: 5,
    },
    "& .MuiListItem-root.Mui-selected, .MuiListItem-root.Mui-selected:hover": {
      backgroundColor: "transparent",
    },
  },
}));

export const useStylesFreezing = makeStyles((theme) => ({
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: "100%",
  },
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  paper: {
    border: "none !important",
    padding: "50px",
    width: "730px",
    position: "relative",
    borderRadius: "10px",
    [theme.breakpoints.down("sm")]: {
      padding: " 20px 20px 20px 20px !important",
      overflow: "auto !important",
      width: "92% !important",
    },
    "&:focus": {
      outline: "none",
    },
  },
}));

export const useStylesSecretSeedModal = makeStyles((theme) => ({
  root: {
    "& > *": {
      margin: theme.spacing(1),
      width: "25ch",
    },
  },
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  paper: {
    border: "none !important",
    padding: "50px",
    width: "730px",
    position: "relative",
    borderRadius: "10px",
    [theme.breakpoints.down("sm")]: {
      padding: " 20px 20px 20px 20px !important",
      width: "92% !important",
    },
    "&:focus": {
      outline: "none",
    },
  },
}));

export const useStylesStoreData = makeStyles((theme) => ({
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: "100%",
  },
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    border: "none !important",
    padding: "50px",
    width: "615px",
    position: "relative",
    borderRadius: "10px",
    [theme.breakpoints.down("sm")]: {
      padding: " 20px 20px 20px 20px !important",
      overflow: "auto !important",
      width: "92% !important",
    },
    "&:focus": {
      outline: "none",
    },
  },
}));

export const useStylesUnFreezing = makeStyles((theme) => ({
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: 200,
  },
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  paper: {
    border: "none !important",
    padding: "50px",
    width: "730px",
    position: "relative",
    borderRadius: "10px",
    [theme.breakpoints.down("sm")]: {
      padding: " 20px 20px 20px 20px !important",
      width: "92% !important",
    },
    "&:focus": {
      outline: "none",
    },
  },
}));
